// 解决babel-runtime不会处理vue和webpack的Promise的问题
if (typeof Promise === 'function') {
  if (!window.Promise) {
    window.Promise = Promise;
  }
}



// WEBPACK FOOTER //
// ../src/util/promisePollfill.js